import { render, staticRenderFns } from "./AutoUpdatedProductsOverview.vue?vue&type=template&id=614fc952&"
import script from "./AutoUpdatedProductsOverview.vue?vue&type=script&lang=js&"
export * from "./AutoUpdatedProductsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports